import { useState, useEffect, useCallback } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import PopularSection from './components/PopularSection';
import FeatureSection from './components/FeatureSection';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [showCategoryGrid, setShowCategoryGrid] = useState(true);

  const handleCategoryChange = useCallback((slug: string) => {
    setActiveCategory(slug);
    if (slug !== 'all') {
      setShowCategoryGrid(true);
    }
    window.scrollTo({ top: 600, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (activeCategory === 'all') {
      setShowCategoryGrid(true);
    }
  }, [activeCategory]);

  return (
    <>
      <SEOHead
        title="棒棒TV - 免费在线观看高清视频 | 不卡顿免缓冲流畅播放"
        description="棒棒TV提供免费在线观看高清视频，不卡顿、免缓冲、流畅播放。海量电视剧全集、电影大全、最新剧集一网打尽。高清画质、极速加载，随时随地畅享精彩影视内容。"
        keywords="棒棒TV,免费在线观看,高清视频,不卡顿,免缓冲,流畅播放,电视剧全集,电影大全,最新剧集,在线观看,免费电影,免费电视剧"
        canonicalUrl="/"
        schemaJson={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          url: 'https://www.bangbangtv.com/',
          name: '棒棒TV',
          description: '棒棒TV提供免费在线观看高清视频，不卡顿、免缓冲、流畅播放。电视剧全集、电影大全、最新剧集一网打尽。',
          inLanguage: 'zh-CN',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.bangbangtv.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav
            activeCategory={activeCategory}
            onCategoryChange={handleCategoryChange}
          />
          {activeCategory === 'all' ? (
            <>
              <PopularSection />
              <FeatureSection />
            </>
          ) : (
            showCategoryGrid && <VideoGrid category={activeCategory} />
          )}
        </main>
        <Footer />
      </div>
    </>
  );
}